module.exports = __webpack_public_path__ + "img/intro_s2_2.ed80a7b3.png";